(function (window, $) {

    $('body').on('click', '.apply-button', applyForAd);

    function applyForAd(e) {
        e.preventDefault();

        var elem = $(this);

        $.ajax({
            type: 'put',
            url: elem.attr('data-url'),
            dataType: 'json',
            success: function (data) {
                ga('send', 'event', 'Ads', 'Successfull ad application', 'Ad Events');

                if (data.type === 'alert-success') {
                    elem.prop('disabled', true);
                    alert(data.content);
                } else {
                    alert(data.content);
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                if (jqXHR.responseText) {
                    try {
                        var data = JSON.parse(jqXHR.responseText);

                        alert(data.content);
                    } catch (SyntaxError) {
                        alert(jqXHR.responseText);
                    }
                } else {
                    alert('Något gick fel, testa att stänga av adblock och försök igen.');
                }
            }
        });
    }

})(window, jQuery);
